export const SIGNUP_REQUESTS_SORTING_CREATION = 'creation_date';
export const SIGNUP_REQUESTS_SORTING_FULL_NAME = 'full_name';
export const SIGNUP_REQUESTS_SORTING_EMAIL = 'email';
export const SIGNUP_REQUESTS_SORTING_STATUS = 'status';
